// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3RtcS","title":"Info_title__1eqKG","selects":"Info_selects__3Vabs","requiredAsterisk":"Info_requiredAsterisk__25Vnb"};